import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function WhyDifferent() {
  const { t } = useLang();
  const content = t.whyDifferent;

  return (
    <section className="relative py-20 md:py-28 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B0F] via-[#12141A] to-[#0A0B0F]" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-6xl font-black font-heading gold-text mb-4">
            {content.title}
          </h2>
          <p className="text-[#9CA3AF] text-lg md:text-xl">
            {content.subtitle}
          </p>
        </motion.div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Competitors */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative overflow-hidden rounded-2xl p-8 md:p-10"
            style={{
              background: 'linear-gradient(135deg, rgba(239,68,68,0.1) 0%, rgba(239,68,68,0.03) 100%)',
              border: '1px solid rgba(239,68,68,0.3)',
            }}
          >
            <h3 className="text-2xl md:text-3xl font-black font-heading text-[#EF4444] mb-8">
              {content.competitors.title}
            </h3>
            <ul className="space-y-4">
              {content.competitors.features.map((feature, i) => (
                <li key={i} className="flex items-start gap-3">
                  <X size={20} className="text-[#EF4444] flex-shrink-0 mt-1" />
                  <span className="text-[#E5E7EB] text-base">{feature}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Us */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative overflow-hidden rounded-2xl p-8 md:p-10"
            style={{
              background: 'linear-gradient(135deg, rgba(34,197,94,0.15) 0%, rgba(34,197,94,0.05) 100%)',
              border: '2px solid rgba(34,197,94,0.4)',
              boxShadow: '0 20px 60px rgba(34,197,94,0.2)',
            }}
          >
            <h3 className="text-2xl md:text-3xl font-black font-heading text-[#22C55E] mb-8">
              {content.us.title}
            </h3>
            <ul className="space-y-4">
              {content.us.features.map((feature, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check size={20} className="text-[#22C55E] flex-shrink-0 mt-1" />
                  <span className="text-white font-medium text-base">{feature}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
